export enum SpinnerSize {
  S = 'small',
  M = 'medium',
  ML = 'small-medium',
  L = 'large',
  XL = 'xlarge',
}
